import { render } from "./TotalReport.vue?vue&type=template&id=5bf54673"
import script from "./TotalReport.vue?vue&type=script&lang=js"
export * from "./TotalReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__